import InternalTracker  from './InternalTracker'
import usePageTracker from './usePageTracker'
import { createTracker, trackerContext, TrackerProvider, useTracker } from './contenxt'
import { TrackerProps, UsePageTrackerProps, TrackerProviderProps } from './types'
import { FC } from 'react'
import trackBuild from './trackDataBuilder'

export type {TrackerProps, UsePageTrackerProps, TrackerProviderProps}

interface TrackerType extends FC<TrackerProps> {
  usePageTracker: typeof usePageTracker
  createTracker: typeof createTracker
  TrackerProvider: typeof TrackerProvider
  useTracker: typeof useTracker
  trackerContext: typeof trackerContext
  trackBuild: (params: any)=>any
}

const Tracker = InternalTracker as TrackerType

Tracker.usePageTracker = usePageTracker
Tracker.createTracker = createTracker
Tracker.TrackerProvider = TrackerProvider
Tracker.useTracker = useTracker
Tracker.trackerContext = trackerContext
Tracker.trackBuild = trackBuild

export default Tracker
